/** Maps a DataError's `reason` field to the message this app shows the signed-in user. */
export function authErrorMessage(data, appName = 'Factor Comps') {
  switch (data?.reason) {
    case 'no_app_access':
      return `Your account does not have access to ${appName}. Ask a DMRE admin.`;
    case 'no_membership':
      return 'Your account does not have access. Ask a DMRE admin.';
    case 'email_unverified':
      return 'Verify your email, then sign in again.';
    default:
      return data?.error || 'Unable to access this organization';
  }
}
